import { API } from "./utils"

export const auth = {
  getUser: () => API.get("/auth/user/", { keepState: false })
}
